'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';
import styles from './Auth.module.css';

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <main className={styles.main}>
      <Link href="/" className={styles.brand} aria-label="МИТС">
        <img
          src="/images/logo-light.svg"
          alt=""
          className={`${styles.brandLogo} ${styles.brandLight}`}
        />
        <img
          src="/images/logo-dark.svg"
          alt=""
          className={`${styles.brandLogo} ${styles.brandDark}`}
        />
      </Link>
      {children}
    </main>
  );
}
